{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "platform-base",
  "roles": [
    "tenant-administrator",
    "security-administrator",
    "auditor"
  ],
  "orgTypes": [
    "part-91-owner",
    "corporate-flight-dept",
    "management-company",
    "part-135",
    "fractional",
    "part-145",
    "independent-mro",
    "mobile-aog",
    "oem-service",
    "component-shop",
    "operator-internal-mx",
    "integrated-135-145"
  ],
  "extensions": [],
  "integrations": []
}